import { Box, styled } from "common/components";

export const StyledBox = styled(Box)(({ theme }) => ({
  paddingTop: undefined,
  position: "sticky",
  top: 0,
  zIndex: 0,
}));
